import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { PageRootWrapper } from '@/components/shared/PageRootWrapper';
import { useUnloadDialog } from '@/hooks/useUnloadDialog';

type Props = {
  children?: ReactNode;
};

export const Confirm: React.FC<Props> = ({ children }) => {
  const { t } = useTranslation();
  const title = t('pages.subscription.new.confirm.title');
  const items = [{ label: title }];

  useUnloadDialog(true);

  return (
    <PageRootWrapper
      title={title}
      headerTitle={title}
      breadcrumbItems={items}
      containerType="normal"
    >
      {children}
    </PageRootWrapper>
  );
};
